export default __webpack_public_path__ + "static/media/idea-bulb.f2398715.png";